export default {
    state: {
      data: false,
    },
    getters: {
      //
    },
    actions: {
      resetPick(context) {
        context.commit("updatePick", false)
      },
    },
    mutations: {
      updatePick(state, data) {
        return state.data = data
      }
    }
  }